import type { LucideIcon } from "lucide-react";

interface SettingsKpiProps {
  icon: LucideIcon;
  label: string;
  value: string;
  tone?: "neutral" | "warning" | "danger";
}

export function SettingsKpi({ icon: Icon, label, value, tone = "neutral" }: SettingsKpiProps) {
  const toneClass =
    tone === "danger"
      ? "border-danger-border text-danger-text"
      : tone === "warning"
        ? "border-warning-border text-warning-text"
        : "border-border text-brand-gold-dark";

  return (
    <div className={`border bg-card px-4 py-3 ${toneClass}`}>
      <div className="flex items-center justify-between gap-3">
        <p className="text-xs font-medium text-muted-foreground">{label}</p>
        <Icon size={16} />
      </div>
      <p className="mt-2 text-2xl font-semibold tabular-nums text-foreground">{value}</p>
    </div>
  );
}
